export default "__VITE_ASSET__Co_cK9bJ__"